export * from './alterar-senha-controller';
